import { Stack } from "@mui/material";
import { formatInteger } from "../../../../../formatters";
import { StepBarSection } from "../../../../../Users/usersApiMapping";
import MobileBarChart from "../../../../MobileBarChart";

interface UsersStepBarSectionProps {
  section: StepBarSection;
}

// Mobile's replacement for the desktop StepSections/UsersStepBarSection.tsx
// - same 3 charts (all/lead/qualified) stacked in the same order as the
// mockup, via MobileBarChart (static value labels) instead of the desktop's
// hover-tooltip pattern (see MobileBarChart.tsx).
export default function UsersStepBarSection({ section }: UsersStepBarSectionProps) {
  return (
    <Stack spacing={1.5}>
      <MobileBarChart title={section.allTitle} data={section.allBars} color="#8E24AA" barLabelFormatter={formatInteger} />
      <MobileBarChart title={section.leadTitle} data={section.leadBars} color="#5B9BD5" barLabelFormatter={formatInteger} />
      <MobileBarChart title={section.qualTitle} data={section.qualBars} color="#2E7D32" barLabelFormatter={formatInteger} />
    </Stack>
  );
}
